import axios from "axios";

export const api = axios.create({
  baseURL: `${import.meta.env?.VITE_BASE_URL}/custom-ui/`,
  withCredentials: true,
});

// Root-level API client for endpoints that don't use the /custom-ui/ prefix
export const apiRoot = axios.create({
  baseURL: `${import.meta.env?.VITE_BASE_URL}/`,
  withCredentials: true,
});
